//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { getLocations } from '~/utils/server'
import { CACHE_SETTINGS } from '~/utils/cache'
import { adaptiveCtx } from '~/utils/v'

export default {
  name: 'OtherLocations',
  props: {
    locationTypes: {
      type: Array,
      default: () => ['country']
    },
    locationLimit: {
      type: Number,
      default: 31
    }
  },
  data () {
    return {
      locations: {}
    }
  },
  async fetch () {
    const ctx = adaptiveCtx(this, { forClient: false })
    this.locations = await this.$cacheFetch({
      key: `pIndex-getLocationsHome?locale=${this.locale}&limit=${31}`, expire: CACHE_SETTINGS.baseTime
    }, async () => {
      return await getLocations(this, {
        lang: this.locale,
        locationType: ctx.locationTypes.map((type) => {
          return {
            id: type
          }
        }),
        locationLimit: this.locationLimit
      })
    })
  },
  computed: {
    ...mapState({
      locale: state => state.lang.locale
    }),
    getLocations () {
      return Object.values(this.locations).flat()
    },
    hasLocations () {
      return this.getLocations?.length
    }
  }
}
